module.exports = __webpack_public_path__ + "static/media/onMarkerting.02f52944.jpg";